export const HAS_DELIVERY_PROMISE = 'HAS_DELIVERY_PROMISE';
export const MISSING_DELIVERY_PROMISE = 'MISSING_DELIVERY_PROMISE';
export const DO_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE = 'DO_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE';
export const DO_NOT_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE = 'DO_NOT_SHOW_MISSING_DELIVERY_PROMISE_MESSAGE';
export const HAS_MULTIPLE_DELIVERY_GROUPS = 'HAS_MULTIPLE_DELIVERY_GROUPS';

export const HAD_SHIP_OPTION_AUTO_SELECTED = 'HAD_SHIP_OPTION_AUTO_SELECTED';
